// @ts-nocheck
import React, { useContext, useState, useEffect } from 'react'
import Context from '../../context/Context';
import { URL } from "../../service/Service";
import { Link, useParams } from 'react-router-dom';
import { editFormElement } from '../../context/forms/FormsAction';
import Breadcrumb from '../Breadcrumb';
import Header from '../TitleAndSubtitle';


const PriceEdit = ({ elementInfo }) => {
    const { idform, idformelement } = useParams()
    const { dispatch } = useContext(Context);
    const [label, setLabel] = useState(elementInfo.label);
    const [required, setRequired] = useState(elementInfo.required);
    const [value, setValue] = useState(elementInfo.element_value);
    const [error, setError] = useState('');
    const pages = [
        {
            name: 'Editar Elementos',
            href: `/forms/${idform}/formeditor`,
            current: false
        },
        {
            name: 'Editar',
            href: `/forms/${idform}/formelements/${idformelement}/edit`,
            current: true
        }
    ];
    useEffect(() => {
        setValue(elementInfo.element_value);
        setLabel(elementInfo.label)
    }, [elementInfo.element_value, elementInfo.label, elementInfo.required]);


    const updateHandler = (nextValue = value) => {
        const url = `${URL}/api/forms/${idform}/formelements/${idformelement}`;
        const request = {
            method: 'PATCH',
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({ value: nextValue, label }),
        };
        editFormElement(url, request, dispatch);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const normalizedValue = String(value ?? '').replace(',', '.');
        if (!Number.isFinite(Number(normalizedValue)) || Number(normalizedValue) < 0.05) {
            setError('O preço mínimo por artigo é 0,05 €.');
            return;
        }
        setValue(normalizedValue);
        setError('');
        updateHandler(normalizedValue);
    };

    return (
        <div className='p-5'>
        <Breadcrumb pages={pages} />
        <div className='mb-5'></div>
        <div className="flex flex-col md:flex-row justify-between items-center">
            <Header title="Editar Elemento" />
        </div>

            <form onSubmit={handleSubmit} className=" bg-white p-6 rounded-lg shadow-md">
                <div className="mb-4">
                    <label for="default-input" className="p-2.5 ext-sm font-bold text-gray-900">Legenda</label>
                    <input
                        className="mt-1 w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5" type="number" min="0.05" step="0.01"
                        onChange={e => setLabel(e.target.value)}
                        Value={label}
                    />
                    <p className="mt-2 text-sm text-gray-500">Valor mínimo: 0,05 €.</p>
                    {error && <p className="mt-2 text-sm text-red-600" role="alert">{error}</p>}
                </div>
                <div className="mb-10">
                    <label for="default-input" className="p-2.5 ext-sm font-bold text-gray-900">Valor</label>

                    <input
                        className="mt-1 w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5" type="text"
                        onChange={e => setValue(e.target.value)}
                        Value={value}
                    />
                </div>
                <div>
                    <button className="mr-4 bg-green-cl hover:bg-opacity-80 text-white py-2 px-4 rounded">
                    Guardar
                    </button>
                </div>
            </form>
        </div>
    );
}

export default PriceEdit
